import React from 'react';

import { TabComponent, TabsContainer } from "./SectionTabs.styles";
import {
    TokenIcon,
    TokensButton
} from '../JobBoard/JobBoard.styles';

interface SectionTabsProps {
    tabs: {
        onClick: () => void,
        isActive: boolean,
        label: string,
        icon?: React.ReactNode
    }[],
    className?: string,
    // T2-6042: tokensCount no longer rendered inside the tabs strip. The DO
    // Job Posts header now surfaces the token / total-posts count separately
    // (TotalPostsCard in JobBoard.tsx). Kept on the props for backwards-compat
    // with any callers that still pass it; will simply be ignored unless
    // showTokensInline is set, but no current caller uses that.
    tokensCount?: number,
    onTokensClick?: () => void,
    showTokensInline?: boolean
}

const SectionTabs = ({ tabs, className, tokensCount, onTokensClick, showTokensInline }: SectionTabsProps) => {
    return (
        <TabsContainer className={className}>
            {tabs.map(({onClick, isActive, label, icon}, index) => (
                <TabComponent
                    key={label}
                    className='no-fastclick'
                    onClick={onClick}
                    $isActive={isActive}
                    $isLast={index === tabs.length - 1}
                >
                    {icon}
                    {label}
                </TabComponent>
            ))}
            {showTokensInline && tokensCount !== undefined && (
                <TokensButton onClick={onTokensClick}>
                    <TokenIcon />
                    <span>{tokensCount}</span>
                </TokensButton>
            )}
        </TabsContainer>
    )
}

export default SectionTabs;
